// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Env } from './env';

export const environment: Env = {
    production: false,
    useEmulators: false,
    oldBackendUrl: 'https://site-apitutti-dev.zafirus.tech',
    // oldBackendUrl: 'https://tuttiservicios.com:3002',
    oldBackendUrlImages: 'https://tuttiservicios.com:3002',
    chatsAPIKEY:"47e44dc158803d43e76889ca9e2964d3a8544e2c5681069efb1877ea93636c63",
    backendUrl: 'https://us-central1-tutti-zafirus-test.cloudfunctions.net',
    defaultLanguage: 'es',
    agentePath:'https://n8n.secretaria-247.com/webhook/',
    mercadoPagoKey: 'TEST-6ffede7a-863c-45a3-8cee-4b957cdfb6ae',
    chatsEndpoint:'wbzghznjhyoeaqmpvmir',
    chatsEndpointKey:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5oZWthcHdiaXFhcnF2bnh1enlsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3OTA4MDksImV4cCI6MjA4MDM2NjgwOX0.kZjkgu6Agn3R-kg6nS_5H8877XCqlx30-hrKBwkKQaI",
    firebase: {
        apiKey: "AIzaSyBWWTQ35JY2uGHWxwk7BrbVTLbDJNh4G5I",
        authDomain: "tutti-zafirus-test.firebaseapp.com",
        projectId: "tutti-zafirus-test",
        storageBucket: "tutti-zafirus-test.firebasestorage.app",
        messagingSenderId: "910999495990",
        appId: "1:910999495990:web:cb1e94f0e83e5184747f97",
        measurementId: "G-RE5CN5Z90X"
    },
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
